import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 52 — GoHighLevel Philippines hiring cluster service-page links.
 *
 * Every Batch 52 article routes its primary commercial link to
 * /gohighlevel-revops-architect. The answer-first leads in batch52Content.ts
 * embed the link directly, but the lead-swap idempotency guard can drop the
 * lead when the Quick Answer duplicates the lead text. This map is the
 * RELIABLE fallback: `injectServiceLink` (contextualLinks.ts) wraps the first
 * in-body occurrence of each anchor phrase in a /gohighlevel-revops-architect
 * link, so the contextual service link always renders regardless of the
 * lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH52_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "hire-gohighlevel-expert-philippines-cost": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /GoHighLevel configurator who builds workflows is not a GoHighLevel architect who designs the system/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-va-philippines-vs-us-specialist": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /GoHighLevel VA who builds workflows is not a US specialist who designs the system/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "vetting-gohighlevel-specialist-philippines": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /GoHighLevel candidate who can configure workflows is not a GoHighLevel specialist who can architect/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-architect-philippines-vs-freelancer": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /marketplace freelancer who builds one workflow is not a Philippines architect who designs/i,
    label: "hire a GoHighLevel RevOps architect",
  },
};
